import { FormGroup } from "@angular/forms";
import { PriceRanges } from "@foxeet/domain";

export const getLimitExcessPriceRange = (form: FormGroup) => {
    const limitExcessRanges = [
        PriceRanges.From3000001,
        PriceRanges.From4_000_001,
        PriceRanges.From6_000_001,]
    let showLimitExcessMessage = false;
    let limitExcessPriceRange = 0;
    let limitExcessPriceRangeText = '';
    

    const priceRangeValue = form?.get('priceRange')?.value;
    showLimitExcessMessage = limitExcessRanges.includes(priceRangeValue);
    switch (priceRangeValue) {
      case PriceRanges.From4_000_001:
        limitExcessPriceRange = 4000000;
        limitExcessPriceRangeText = '4M';
        break;
      case PriceRanges.From3000001:
        limitExcessPriceRange = 3000000;
        limitExcessPriceRangeText = '3M';
        break;
      case PriceRanges.From6_000_001:
        limitExcessPriceRange = 6000000;
        limitExcessPriceRangeText = '6M';
        break;
      default:
        break;
    }
    return {
        showLimitExcessMessage,
        limitExcessPriceRange,
        limitExcessPriceRangeText
    };  
}